import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { Transform } from "class-transformer";
import { stringToBoolean } from "../../types-transformers/boolean-transformers";

export class InterestsFilter extends PaginationFilter {
	@Transform(stringToBoolean)
	public exactCaseInsensitiveSearch?: boolean;

	public search?: string;
	public sourceIds?: string[];
}
